import React from "react";
import styled from "styled-components";
import { FaTiktok, FaInstagram, FaYoutube } from "react-icons/fa";

const pastWinners = [
  {
    id: 1,
    week: "Wk 1",
    text: "Monster Top Speed hoodie",
    suggestedBy: "@Ondra10x10",
    tiktokUrl: "https://www.tiktok.com/@adampotocnik/video/7626789007313095956?lang=en",
    instagramUrl: "https://www.instagram.com/p/DW6rBZ7igI2/",
  },
  {
    id: 2,
    week: "Wk 2",
    text: "Balenciaga x Ultra Black Monster",
    suggestedBy: "@coudekk",
    suggestedByUrl: "https://www.instagram.com/coudekk/",
    tiktokUrl: "https://www.tiktok.com/@adampotocnik/video/7630878446402407700",
    instagramUrl: "https://www.instagram.com/p/DXXDSUhCr-7/",

  }
];

export default function SuggestionsTab() {
  return (
    <Wrap>
      <TopCard>
        <Eyebrow>Suggestions paused</Eyebrow>
        <Title>Suggestions are closed for now.</Title>
        <Sub>
          Follow me on socials to know when I open submissions again.
        </Sub>

        <SocialRow>
          <SocialLink
            href="https://www.tiktok.com/@adampotocnik"
            target="_blank"
            rel="noreferrer"
            aria-label="TikTok"
          >
            <FaTiktok />
          </SocialLink>

          <SocialLink
            href="https://www.instagram.com/adampotocnik/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram />
          </SocialLink>

          <SocialLink
            href="https://www.youtube.com/@adampotocnik"
            target="_blank"
            rel="noreferrer"
            aria-label="YouTube"
          >
            <FaYoutube />
          </SocialLink>
        </SocialRow>
      </TopCard>

      <PastCard>
        <SectionTitle>Previous winners</SectionTitle>

        <PastList>
          {pastWinners.map((item) => (
            <PastRow key={item.id}>
              <PastWeek>{item.week}</PastWeek>

              <PastMain>
                <PastIdea>{item.text}</PastIdea>

                <PastMeta>
                  Suggested by:{" "}
                  {item.suggestedByUrl ? (
                    <SuggestedByLink
                      href={item.suggestedByUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.suggestedBy}
                    </SuggestedByLink>
                  ) : (
                    item.suggestedBy
                  )}
                </PastMeta>

                <WinnerLinks>
                  {item.tiktokUrl && (
                    <WinnerIconLink
                      href={item.tiktokUrl}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="TikTok video"
                      title="Watch on TikTok"
                    >
                      <FaTiktok />
                    </WinnerIconLink>
                  )}

                  {item.instagramUrl && (
                    <WinnerIconLink
                      href={item.instagramUrl}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Instagram post"
                      title="Watch on Instagram"
                    >
                      <FaInstagram />
                    </WinnerIconLink>
                  )}

                  {item.youtubeUrl && (
                    <WinnerIconLink
                      href={item.youtubeUrl}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="YouTube video"
                      title="Watch on YouTube"
                    >
                      <FaYoutube />
                    </WinnerIconLink>
                  )}
                </WinnerLinks>
              </PastMain>
            </PastRow>
          ))}
        </PastList>
      </PastCard>
    </Wrap>
  );
}

/* ---------- styles ---------- */

const Wrap = styled.section`
  max-width: 760px;
  margin: 0 auto;
  width: 100%;
  padding: 32px 20px 64px;
  display: grid;
  gap: 16px;
`;

const TopCard = styled.div`
  border: 1px solid var(--faint);
  background: var(--surface);
  padding: 24px;
`;

const Eyebrow = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--muted);
  margin-bottom: 10px;
`;

const Title = styled.h2`
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
  font-size: clamp(26px, 5vw, 48px);
  line-height: 1.05;
  margin: 0 0 10px 0;
  color: var(--ink);
`;

const Sub = styled.div`
  font-size: 13px;
  color: var(--muted);
  line-height: 1.6;
`;

const SocialRow = styled.div`
  margin-top: 18px;
  display: flex;
  gap: 12px;
`;

const SocialLink = styled.a`
  width: 42px;
  height: 42px;
  border: 1px solid var(--faint);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink);
  background: transparent;
  text-decoration: none;
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--ink);
    transform: translateY(-1px);
  }

  svg {
    font-size: 18px;
  }
`;

const PastCard = styled.div`
  border: 1px solid var(--faint);
  background: var(--surface);
  padding: 22px;
`;

const SectionTitle = styled.h3`
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink);
  margin: 0 0 16px 0;
`;

const PastList = styled.div`
  display: grid;
  gap: 0;
`;

const PastRow = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 14px;
  padding: 16px 0;
  border-top: 1px solid var(--faint);

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`;

const PastWeek = styled.div`
  font-size: 11px;
  color: var(--muted);
  padding-top: 3px;
`;

const PastMain = styled.div`
  min-width: 0;
`;

const PastIdea = styled.div`
  font-size: 15px;
  color: var(--ink);
  line-height: 1.45;
`;

const PastMeta = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: var(--muted);
`;

const SuggestedByLink = styled.a`
  color: var(--ink);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.15s ease;

  &:hover {
    border-bottom-color: var(--ink);
  }
`;

const WinnerLinks = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
`;

const WinnerIconLink = styled.a`
  width: 34px;
  height: 34px;
  border: 1px solid var(--faint);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink);
  text-decoration: none;
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--ink);
    transform: translateY(-1px);
  }

  svg {
    font-size: 15px;
  }
`;